export const categoryActions = {
  LOADING: "LOADING",
  ERROR: "ERROR",
  GET_CATEGORY: "GET_CATEGORY",
};
